// r24 — /en/translate/naati/au/$slug
import { createFileRoute, notFound } from "@tanstack/react-router";
import NaatiAuCityRenderer from "@/components/NaatiAuCityRenderer";
import { NAATI_AU_CITIES } from "@/data/naati-au-cities";
import { canonicalAndHreflang, ctaDesc, ctaTitle } from "@/lib/seo";

const SITE = "https://nyclanguageinstitute.com";

export const Route = createFileRoute("/en/translate/naati/au/$slug")({
  loader: ({ params }) => {
    const c = NAATI_AU_CITIES.find((x) => x.slug === params.slug);
    if (!c) throw notFound();
    return { city: c };
  },
  head: ({ params }) => {
    const c = NAATI_AU_CITIES.find((x) => x.slug === params.slug);
    if (!c) return { meta: [{ title: ctaTitle("Not found", "/en/translate/naati/au/$slug", "en")}, { name: "robots", content: "noindex" }] };
    const url = `${SITE}/en/translate/naati/au/${c.slug}`;
    const title = `NAATI Translation to ${c.nameEn}, ${c.stateEn} — DHL ${c.postageEtaFromBkk} | NYC`;
    const desc = `NAATI Certified translation shipped from Bangkok to ${c.nameEn} for ${c.popularVisas.slice(0, 3).join(", ")}. Get your checklist in minutes.`;
    return {
      meta: [
        { title: ctaTitle(title, "/en/translate/naati/au/$slug", "en") }, { name: "description", content: ctaDesc(desc, "/en/translate/naati/au/$slug", "en")},
        { property: "og:title", content: ctaTitle(title, "/en/translate/naati/au/$slug", "en")}, { property: "og:description", content: ctaDesc(desc, "/en/translate/naati/au/$slug", "en")},
        { property: "og:url", content: url }, { property: "og:locale", content: "en_US" },
      ],
      links: canonicalAndHreflang(`/translate/naati/au/${c.slug}`, `/en/translate/naati/au/${c.slug}`),
      scripts: [
        { type: "application/ld+json", children: JSON.stringify({
          "@context": "https://schema.org", "@type": "Service", inLanguage: "en",
          name: `NAATI Translation delivered to ${c.nameEn}`,
          areaServed: { "@type": "City", name: c.nameEn, address: { "@type": "PostalAddress", addressRegion: c.stateEn, addressCountry: "AU" } },
          provider: { "@type": "Organization", name: "NYC Language Institute", url: SITE },
          url,
        }) },
      ],
    };
  },
  component: () => {
    const { city } = Route.useLoaderData();
    return <NaatiAuCityRenderer locale="en" city={city} />;
  },
});
